import { render } from "./AgentRate.vue?vue&type=template&id=9c8b1e72"
import script from "./AgentRate.vue?vue&type=script&lang=js"
export * from "./AgentRate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__